import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";

// Dialog pentru adăugarea unui membru nou în grup.
export function AddMemberDialog({ open, onOpenChange, value, onChange, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[340px] rounded-3xl">
        <DialogHeader>
          <DialogTitle className="font-heading">Adaugă un membru</DialogTitle>
          <DialogDescription>Scrie numele prietenului pe care vrei să-l adaugi în grup.</DialogDescription>
        </DialogHeader>
        <Input
          data-testid="new-member-input"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onSubmit()}
          placeholder="Numele prietenului"
          className="h-12 rounded-xl"
          autoFocus
        />
        <DialogFooter>
          <Button
            data-testid="confirm-add-member-btn"
            onClick={onSubmit}
            className="w-full rounded-xl bg-emerald-600 hover:bg-emerald-700 py-6 font-bold"
          >
            Adaugă
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
